export default __webpack_public_path__ + "static/media/vaultcertifiedimg.929ffca9.png";